import "./style.scss";
import DefaultListItem from "../../Default/ListItem";
import hearth from "../img/hearth.png";
import sberCat from "../img/sber_cat.png";

const ListItem = ({ isSberPrime = false, ...props }) => {
    if (!isSberPrime) {
        return <DefaultListItem {...props} />;
    }

    const { handleClick = () => {}, typeLabel = "хит", item = null } = props;

    return (
        item && (
            <div className={`ab-4031-v2 list-item hit`} id={item._id} onClick={handleClick}>
                <div className="list-item__logo">
                    <img alt={`logo_desktop`} src={sberCat} />
                </div>
                <div className="list-item__title-container">
                    <span className={`list-item__title`} dangerouslySetInnerHTML={{ __html: item.title }}></span>
                </div>
                <span className={`list-item__hit-label_block hit`}>{typeLabel}</span>
                <img alt="hearth" className="list-item__sber-hearth" src={hearth} />
            </div>
        )
    );
};

export default ListItem;
